export const SettingsView = () => {
    return(
        <p>Example</p>
    )
}